import React, { useState } from 'react';
import { useAlert } from 'react-alert';
import { Auth } from 'aws-amplify';
import * as Yup from 'yup';
import { ErrorMessage, Field, Formik } from 'formik';
import Base, { ContentContainer } from '../../components/Base';
import { Button, Form, FormControl, H1, Hint, InputError } from '../../assets/styles/GlobalStyles';
import { passwordValidation, verifyError } from '../../utils/verifyErrors';
import { Input } from '../../components/Base/Elements';
import { translate } from '../../i18n/index';
import { changePassword } from '../../services/services';
import { createCookie } from '../../utils/cookies';

const NewPassword = (props) => {
    const alert = useAlert();
    const hasUsername = props ? props.username || '' : '';
    const responseSignIn = props ? props.responseSignIn || '' : '';
    const [passwordValidate, setPasswordValidate] = useState({
        min: false,
        number: false,
    });

    return (
        <Base>
            <ContentContainer>
                <Formik
                    enableReinitialize
                    initialValues={{
                        username: hasUsername,
                        code: '',
                        password: '',
                    }}
                    validationSchema={Yup.object().shape({
                        username: Yup.string().required(translate('validateRequired')),
                        password: Yup.string()
                            .required(translate('validateRequired'))
                            .min(6, translate('validatePasswordMin'))
                            .max(6, translate('validatePasswordMax'))
                            .matches(/^\d+$/, translate('validatePasswordOnlyNumbers'))
                    })}
                    onSubmit={async (values, actions) => {
                        if (values) {
                            try {
                                await Auth.completeNewPassword(responseSignIn, values.password);
                                alert.show(translate('forgotPasswordExceptionPasswordChangedSuccessfully'), {
                                    closeCopy: 'Fechar',
                                    onOpen: async () => {
                                    }
                                });
                                const response = await Auth.signIn(hasUsername, values.password);                                    
                                createCookie(response);
                                await changePassword({ plainPassword: values.password });
                                await props.redirect(response, values.password.trim());
                            } catch (e) {
                                alert.show(verifyError(e.code, e.message), {
                                    closeCopy: 'Fechar',
                                });
                            }
                        }
                        actions.setSubmitting(false);
                    }}>
                    {({ isSubmitting }) => (
                        <Form>
                            <H1>{translate('newPasswordTitle')}</H1>

                            <FormControl>
                                <Field
                                    name="username"
                                    placeholder={translate('inputUsername')}
                                    disabled
                                    component={Input}
                                />
                                <ErrorMessage name="username" component={InputError} />
                            </FormControl>
                            <FormControl>
                                <Field
                                    type="password"
                                    name="password"
                                    onInput={(value) => {
                                        passwordValidation(value.target.value, setPasswordValidate);
                                    }}
                                    placeholder={translate('inputNewPassword')}
                                    component={Input}
                                />
                                <ErrorMessage name="password" component={InputError} />
                                <Hint>
                                    <div>{translate('inputPasswordHintTitle')}</div>
                                    <ul>
                                        <li className={`${passwordValidate.min ? 'complete' : ''}`}>
                                            {translate('inputPasswordHint1')}
                                            <br />
                                            {translate('inputPasswordHint6')}
                                        </li>
                                    </ul>
                                </Hint>
                            </FormControl>
                            <FormControl>
                                <Button type="submit" disabled={isSubmitting}>
                                    {isSubmitting ? translate('buttonSending') : translate('buttonSend')}
                                </Button>
                            </FormControl>
                        </Form>
                    )}
                </Formik>
            </ContentContainer>
        </Base>
    );
};

export default NewPassword;
